/**
 * Loads IBM Plex Sans to match @didomi/ui-foundation typography tokens
 * (see node_modules/@didomi/ui-foundation/dist/typography/index.scss).
 *
 * Same approach as consent-notices-spa notice preview HTML:
 * https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:…
 * We request 400–700 so body, medium, and semibold styles resolve correctly.
 */
export function ensureIbmPlexSansFonts(): void {
  if (document.querySelector('link[data-oauth-ui-fonts="ibm-plex-sans"]')) {
    return;
  }

  const preconnectGoogle = document.createElement('link');
  preconnectGoogle.rel = 'preconnect';
  preconnectGoogle.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnectGoogle);

  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectGstatic);

  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap';
  stylesheet.setAttribute('data-oauth-ui-fonts', 'ibm-plex-sans');
  document.head.appendChild(stylesheet);
}
